import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbGlobe: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
        <g id='Box'>
          <rect fill='none' width={size} height={size} />
        </g>
        <g id='Final_icons_-_Common' data-name='Final icons - Common'>
          <path d='M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm2.7,2.48L12.88,6.3h-.82l-2-2A8.08,8.08,0,0,1,12,4,7.83,7.83,0,0,1,14.7,4.48ZM4,12a8,8,0,0,1,.27-2H7.72v1.47H6.31l-.5.5v1.66l.5.5H9.5v2.37L7.42,18.55A8,8,0,0,1,4,12Zm4.29,7.08L10.36,17l.14-.35V13.59l-.5-.5H6.81v-.66H8.22l.5-.5V9.46L8.22,9H4.6A8,8,0,0,1,9,4.61L11.5,7.15l.35.15h1.23l.36-.15,2.24-2.24a7.89,7.89,0,0,1,1.53,1l-4.82,4.87-.14.35v2.31l.5.5h2.14v2.71L15,17l1.52,1.53a7.94,7.94,0,0,1-8.27.52Zm9.06-1.15-1.46-1.46v-3l-.5-.5H13.25V11.36l4.67-4.72a8,8,0,0,1-.57,11.29Z' />
        </g>
      </svg>
    </>
  );
};
